export default __webpack_public_path__ + "static/media/scan.94794e4f.svg";